// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"fe412a0f","306":"698a74d0","345":"456c6258","551":"84338da6","560":"f1f6829e","837":"9cbbef02"}[chunkId] + ".chunk.js";
};